import React from "react";
import { Typography, IconButton } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import { sendGetCartsPayload } from "features/sendGetCartsPayload";
import { useDataContext, useUserStateContext } from "App";
import { useDispatch } from "react-redux";
import { useWebsocketContext } from "authsignin/AuthedPage";
import { debounce } from "lodash";

const RefreshCartsBtn = React.memo(function RefreshCartsBtn() {
  const { connectedVendorCodes } = useDataContext();
  const { userCreds } = useUserStateContext();
  const { sendDgiJsonMessage } = useWebsocketContext();
  const dispatch = useDispatch();

  const handleRefreshCarts = () => {
    sendGetCartsPayload(
      userCreds?.cognitoID,
      sendDgiJsonMessage,
      dispatch,
      connectedVendorCodes
    );
  };

  const debouncedHandleRefresh = debounce(handleRefreshCarts, 300);

  return (
    <IconButton
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "8px",
        borderRadius: "4px",
        boxShadow: "inset 0 -2px 4px -2px rgba(0, 0, 0, 0.1)",
        width: "fit-content",
        border: "1px solid #d2d6da",
        cursor: "pointer",
        "&:hover": {
          backgroundColor: "#f4f4f4",
        },
      }}
      className="bg-grayscaleWhite"
      onClick={debouncedHandleRefresh}
    >
      <RefreshIcon
        sx={{ fontSize: "1.33rem" }}
        className="mr-[8px] fill-blueblue"
      />
      <Typography
        variant="button"
        color="primary"
        className="normal-case text-blueblue text-base"
      >
        Refresh Carts
      </Typography>
    </IconButton>
  );
});

export default RefreshCartsBtn;
